//____ TABS SWITCH CONTENT ____ //
//____ AUTHOR: LUBOMÍR BLAŽEK ____ //
$.fn.nl_switch = function () {
    var $this = $(this),
            $nav = "[data-switch-nav]",
            $area = "[data-switch-area]",
            $nav_item = $this.find($nav).children();

    $nav_item.each(function (n) {
        $(this).on("click", function (e) {
            e.preventDefault();
            $(this).closest($nav).children().removeClass("active");
            $(this).addClass("active");
            $(this).closest($this).find($area).children().hide().css("opacity", "0").removeClass("active");
            $(this).closest($this).find($area).children().eq(n).show().css("opacity", "1").addClass("active");
        });
    });
};